export default "__VITE_ASSET__DqzVHwwW__"